// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2M-_i","productName":"Table_productName__26gzF"};